import React, { Component } from "react";
import CalendarHeader from "./CalendarHeader";
import CalendarBody from "./CalendarBody";
import { MONTHS, MONTHS_SHORT } from "./constants";
import { isSet } from "../../utils/commonUtils";
import Buttons from "../UI/Buttons";
import { getDateRangeHandler } from "./calendarFunctions";
import withReduxState from "../../hoc/wReduxState";
import { fetchCurrentDate } from "../../utils/DateUtils";
import FormInputs from "../UI/FormInputs";
import PERMISSIONS from "../../utils/AclPermissions";

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarOptions: {
        showWeekends: false,
      },
      direction: null,
      currentDay: this.props.currentDay,
      calendarLabel:
        MONTHS[fetchCurrentDate().getMonth()] +
        " " +
        fetchCurrentDate().getFullYear(),
      isShowMorePopup: false,
      isShowQuickViewPopup: false,
      anchorTagPosition: {},
      popupCalendarEvent: {},
      quickViewDetails: {},
      popupCalendarData: { dateTime: {}, data: [] },
    };
  }

  componentDidMount = (prevProps, prevState) => {
    const { calendarViewType } = this.props;
    this.setState({
      currentDay: isSet(this.props.currentDay, fetchCurrentDate()),
      calendarLabel: this.updateCalendarLabel(
        this.state.currentDay,
        calendarViewType
      ),
    });
    // this.scrolIntoStartingtime();
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevProps.currentDay !== this.props.currentDay &&
      prevProps.isCalendarWidgetDate !== this.props.isCalendarWidgetDate
    ) {
      this.currentDayChangeHandler(this.props.currentDay, this.state.direction);
      // this.scrolIntoStartingtime();
    }
    // const elemt = document.getElementById("calendarRow_0700");
    // const rect = element.getBoundingClientRect();  // Get the element's position relative to the viewport
    // const topPosition = rect.top + window.pageYOffset; // Add the current scroll position to get the top relative to the document
    // console.log("Top position:", topPosition);
    // console.log('this.props',this.props);
    // document.getElementById("calendarRow_0700").scrollIntoView({
    //     behavior: "smooth",  // Optional: for smooth scrolling
    //     block: "start",     // Scroll the element to the center of the viewport
    //     inline: "nearest"    // Aligns the element vertically and horizontally
    // });

    if (prevState.isShowQuickViewPopup !== this.state.isShowQuickViewPopup) {
      var popup = document.getElementById("calendarQuickViewPopup");
      if (popup) {
        // Ensure the element is focusable
        popup.setAttribute("tabindex", "-1");
        // Scroll the element into view
        popup.scrollIntoView({ behavior: "smooth", block: "nearest" });
        // Focus the element
        // popup.focus();
      }
    }
    if (prevState.isShowMorePopup !== this.state.isShowMorePopup) {
      var popup = document.getElementById("calendarViewMorePopup");
      if (popup) {
        // Ensure the element is focusable
        popup.setAttribute("tabindex", "-1");
        // Scroll the element into view
        popup.scrollIntoView({ behavior: "smooth", block: "nearest" });
        // Focus the element
        // popup.focus();
      }
    }
  };

  // scrolIntoStartingtime = ()=>{
  // const checkInterval = 100;
  // const maxAttempts = 20;
  // let attempts = 0;
  // const intervalId = setInterval(() => {
  // const element = document.getElementById("calendarRow_0730");

  // if (element) {
  //     element.scrollIntoView({
  //     behavior: "smooth",  // Optional: for smooth scrolling
  //     block: "start",     // Scroll the element to the start of the viewport
  //     inline: "nearest"   // Aligns the element vertically and horizontally
  //     });
  //     clearInterval(intervalId); // Clear the interval
  // } else if (attempts >= maxAttempts) {
  //     // Stop checking if the maximum number of attempts is reached
  //     clearInterval(intervalId);
  //     // console.log("Element not found after maximum attempts");
  // }
  // attempts++;
  // }, checkInterval);
  // }
  calendarOptionOnChangeHandler = (key, val) => {
    // console.log('key,val',key,val);
    this.setState({
      calendarOptions: {
        ...this.state.calendarOptions,
        [key]: val,
      },
    });
  };
  showMoreCalendarGridForm = (e, dateItem, calendarData) => {
    // Prevent default behavior of the anchor tag
    e.stopPropagation();
    e.preventDefault();
    const closestTr = e.target.closest("td").querySelector("a");
    // console.log("closestTr", closestTr);
    const cellRect = closestTr.getBoundingClientRect();
    const calendarDiv = document.getElementById("calendar");
    const calendarRect = calendarDiv.getBoundingClientRect();

    // Calculate position relative to the calendar, considering scroll position
    const topRelativeToCalendar =
      cellRect.top - calendarRect.top + calendarDiv.scrollTop;

    // Calculate the left position relative to the viewport
    const leftRelativeToViewport = cellRect.left - calendarRect.left;

    // const rightRelativeToViewport = cellRect.right - calendarRect.right;
    const widthRelativeToViewport = cellRect.width - calendarRect.width;

    // Get viewport dimensions
    const viewportWidth = window.innerWidth;

    // if(right)
    // Adjust the left position if the popup overflows the right edge of the viewport
    const popupWidth = 240;

    let left = leftRelativeToViewport;
    if (leftRelativeToViewport + popupWidth > viewportWidth) {
      left = viewportWidth - popupWidth;
    }
    // console.log('calendarRect',cellRect.width,calendarRect.width);
    // console.log('calendarRect',Math.abs(widthRelativeToViewport)<Math.abs(leftRelativeToViewport+popupWidth),Math.abs(widthRelativeToViewport)-Math.abs(leftRelativeToViewport+popupWidth));
    if (
      Math.abs(widthRelativeToViewport) <
      Math.abs(leftRelativeToViewport + popupWidth)
    ) {
      // console.log('Beforeleft',left);
      left =
        left -
        Math.abs(
          Math.abs(widthRelativeToViewport) -
            Math.abs(leftRelativeToViewport + popupWidth)
        );
      // console.log('Afterleft',left);
    }
    // if(0>rightRelativeToViewport){
    //     left = (left-rightRelativeToViewport)-popupWidth;

    // }
    const anchorTagPosition = {
      top: topRelativeToCalendar + cellRect.height - 30,
      left: left,
    };

    this.setState({
      isShowMorePopup: true,
      anchorTagPosition: anchorTagPosition,
      popupCalendarEvent: e,
      popupCalendarData: { dateTime: dateItem, data: calendarData },
    });
  };

  showQuickVisitView = (e, calendarData) => {
    // Prevent default behavior of the anchor tag
    e.stopPropagation();
    e.preventDefault();
    const { popupCalendarEvent } = this.state;
    const evnt = e; //Object.entries(popupCalendarEvent).length===0?e:popupCalendarEvent;
    let closestTr = {};
    try {
      closestTr = evnt.target.closest("td").querySelector("a");
    } catch (e) {
      closestTr = popupCalendarEvent.target.closest("td").querySelector("a");
    }

    const cellRect = closestTr.getBoundingClientRect();
    const calendarDiv = document.getElementById("calendar");
    const calendarRect = calendarDiv.getBoundingClientRect();

    // Calculate position relative to the calendar, considering scroll position
    const topRelativeToCalendar =
      cellRect.top - calendarRect.top + calendarDiv.scrollTop;

    // Calculate the left position relative to the viewport
    const leftRelativeToViewport = cellRect.left - calendarRect.left;

    // const rightRelativeToViewport = cellRect.right - calendarRect.right;
    const widthRelativeToViewport = cellRect.width - calendarRect.width;

    // Get viewport dimensions
    const viewportWidth = window.innerWidth;

    // if(right)
    // Adjust the left position if the popup overflows the right edge of the viewport
    const popupWidth = 340; //240;

    let left = leftRelativeToViewport;
    if (leftRelativeToViewport + popupWidth > viewportWidth) {
      left = viewportWidth - popupWidth;
    }
    if (
      Math.abs(widthRelativeToViewport) <
      Math.abs(leftRelativeToViewport + popupWidth)
    ) {
      left =
        left -
        Math.abs(
          Math.abs(widthRelativeToViewport) -
            Math.abs(leftRelativeToViewport + popupWidth)
        );
    }
    // if(0>rightRelativeToViewport){
    //     left = (left-rightRelativeToViewport)-popupWidth;

    // }
    const anchorTagPosition = {
      top: topRelativeToCalendar + cellRect.height - 30,
      left: left,
    };

    this.setState({
      isShowQuickViewPopup: true,
      // isShowMorePopup:
      anchorTagPosition: anchorTagPosition,
      quickViewDetails: calendarData,
    });
  };

  openViewMorePopupToogle = () => {
    this.setState({ isShowMorePopup: !this.state.isShowMorePopup });
  };
  openQuickVisitViewPopupToogle = () => {
    this.setState({ isShowQuickViewPopup: !this.state.isShowQuickViewPopup });
  };

  // Get all calendarRecords into a single array and filter by visit_status
  // calendarRecords format: {"02/03/2026": Array(12), "02/01/2026": Array(6), ...}
  getAllAppointments = () => {
    const { calendarRecords } = this.props;
    if (!calendarRecords || typeof calendarRecords !== 'object') {
      return [];
    }
    
    // Flatten all calendarRecords into a single array
    // Object.values() extracts all arrays, .flat() combines them into one array
    const allAppointments = Object.values(calendarRecords)
      .filter(Array.isArray) // Ensure each value is an array
      .flat();
    
    // Filter appointments that have a visit_status (or return all if you want to count all)
    // If you want to count only appointments with visit_status, uncomment the filter below
    // return allAppointments.filter(appointment => appointment.visit_status);
    
    return allAppointments;
  };

  // Count appointments by visit_status
  getAppointmentCounts = () => {
    const allAppointments = this.getAllAppointments();
    console.log('allAppointments',allAppointments);
    // Total count of all appointments
    const totalAppointments = allAppointments.length;
    
    // Filter and count by specific statuses
    // checkedin: all appointments that are NOT "Discharged"/"Discharge" and NOT "Completed"/"Complete & Discharged"
    const checkedin = allAppointments.filter(appointment => {
      const status = (appointment.visit_status || '').toLowerCase();
      return status === 'checked in';
    }).length;
    
    // Discharge: appointments where visit_status is "Discharged" or "Discharge"
    const Discharge = allAppointments.filter(appointment => {
      const status = (appointment.visit_status || '').toLowerCase();
      return status === 'ready for discharge';
    }).length;
    
    // completed: appointments where visit_status is "Completed" or "Complete & Discharged"
    const completed = allAppointments.filter(appointment => {
      const status = (appointment.visit_status || '').toLowerCase();
      return status === 'completed' || status.includes('complete & discharged');
    }).length;

    return {
      total: totalAppointments,
      checkedin: checkedin,
      Discharge: Discharge,
      completed: completed
    };
  };

  render() {
    console.log('this.props',this.props.calendarRecords);
    const {
      calendarOptions,
      calendarLabel,
      currentDay,
      isShowMorePopup,
      isShowQuickViewPopup,
      quickViewDetails,
      popupCalendarData,
      anchorTagPosition,
    } = this.state;
    const {
      calendarViewType,
      visitStatusOption,
      scheduledType,
      setActiveScheduled,
      clinic_id,
      clinicOptions,
    } = this.props;

    // Get appointment counts
    const appointmentCounts = this.getAppointmentCounts();
    return (
      <>
        <div className="sh_cardHeader">
          <div className="form-group d-flex mb-0 justify-content-between align-items-center">
            {/*<h6 className="text-lg f-500 mb-0"> Appointments </h6>*/}

            <div className="d-flex ">
              <div class="px-1">
                <input
                  class="form-control  form-control-solid "
                  placeholder="Search"
                  value=""
                />
              </div>
              <CalendarHeader
                {...this.props}
                calendarViewType={calendarViewType}
                calendarOptions={calendarOptions}
                currentDay={currentDay}
                label={calendarLabel}
                // visitStatusOption={visitStatusOption}

                calendarOptionOnChangeHandler={
                  this.calendarOptionOnChangeHandler
                }
                currentDayChangeHandler={this.currentDayChangeHandler}
                viewTypeChangeHandler={this.calendarViewTypeChangeHandler}
              />
            </div>
            <div className="d-flex gap-2">
              <span className="ml-1">
                <Buttons
                  iconType="NewQrIcon"
                  clickHandler={this.props.scanBarcodeHandler}
                  className="btn btn-light sh_btnlight rsp-icon-only-btn"
                  acl={"appointment-scan_barcode"}
                  label={"  Scan barcode"}
                  title="Scan barcode"
                />
              </span>
              <span className="">
                <Buttons
                  iconType="NewAddVisitIcon"
                  clickHandler={this.props.addVisitToogleHandler}
                  className="btn btn-primary sh_btnprimary rsp-icon-only-btn"
                  acl={PERMISSIONS.VISITS.CREATE}
                  // appendAddIcon={true}
                  label={"  Add New Visit"}
                  title="Add New Visit"
                />
              </span>

              <span className="">
                <Buttons
                  iconType="NewAddPatientIcon"
                  clickHandler={() => this.props.addNewEmployeeToogleHandler(true)}
                  className="btn btn-primary sh_btnprimary rsp-icon-only-btn"
                  acl={PERMISSIONS.EMPLOYEE.CREATE}
                  // appendAddIcon={true}
                  label={"  Add Patient"}
                  title="Add Patient"
                />
              </span>
              <FormInputs
                type="SelectList"
                value={clinic_id}
                changeHandler={(val) => {
                  this.props.onClinicChange(val);
                }}
                options={clinicOptions}
                className="form-control mx-1 mr-2"
              />
            </div>
          </div>
          <div className="form-group d-flex mb-0 justify-content-end align-items-center mt-1">
            <div className="ml-2">
              <div className="tabs_wrapForTable">
                <ul className="nav sh_subnav border-0">
                  {scheduledType.map((itm, itmInd) => (
                    <li key={itmInd}>
                      <a
                        href="#"
                        className={`flex-sm-fill text-sm-center text-dark nav-link ${
                          itm.isActive ? "active" : ""
                        }`}
                        aria-current={itm.isActive ? "page" : undefined}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveScheduled(itm);
                        }}
                      >
                        {itm.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          {/* Appointments card start here */}
          <div className="sh_cardHeader px-0">
          <div className="row">
            <div className="col-lg-3 col-6 py-1">
              <div className="d-flex sh_statusIndicatorbox blue-orichid px-3 py-2">
                <div className="d-flex align-items-center ">
                  <span className="sh_statusIndicator bg-light">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path fill-rule="evenodd" clip-rule="evenodd" d="M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                       <path d="M16 3V6" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                       <path d="M12 3V6" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                       <path d="M8 3V6" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                       <path d="M12 16H17" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                       <path d="M8.63389 15.1161C9.12204 15.6043 9.12204 16.3957 8.63389 16.8839C8.14573 17.372 7.35428 17.372 6.86612 16.8839C6.37796 16.3957 6.37796 15.6043 6.86612 15.1161C7.35427 14.628 8.14573 14.628 8.63389 15.1161" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                       <path d="M12 11H17" stroke="#323232" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                       <path d="M8.63389 10.1161C9.12204 10.6043 9.12204 11.3957 8.63389 11.8839C8.14573 12.372 7.35428 12.372 6.86612 11.8839C6.37796 11.3957 6.37796 10.6043 6.86612 10.1161C7.35427 9.62796 8.14573 9.62796 8.63389 10.1161" stroke="#323232" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                  </span>
                </div>
                <div className="d-flex flex-column">
                  <p className="p1-light text-dark mb-0">Total-Appointments</p>
                  <h3 className="h3-strong mb-0">{appointmentCounts.total}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-6 py-1">
              <div className="d-flex sh_statusIndicatorbox pale-purple px-3 py-2">
                <div className="d-flex align-items-center ">
                  <span className="sh_statusIndicator bg-light">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 3V6" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16.5 3V6" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10 21H6C4.34315 21 3 19.6569 3 18V7.5C3 5.84315 4.34315 4.5 6 4.5H18C19.6569 4.5 21 5.84315 21 7.5V10" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M17.8685 18.7361L16.6309 17.4989L17.8685 16.2617" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <circle cx="17.5" cy="17.5" r="4.5" stroke="#1D1917" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                  </span>
                </div>
                <div className="d-flex flex-column">
                  <p className="p1-light text-dark mb-0">Checked-In</p>
                  <h3 className="h3-strong mb-0">{appointmentCounts.checkedin}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-6 py-1">
              <div className="d-flex sh_statusIndicatorbox linear_gradient px-3 py-2">
                <div className="d-flex align-items-center ">
                  <span className="sh_statusIndicator bg-light">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 3V6" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16.5 3V6" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 21H6C4.34315 21 3 19.6569 3 18V7.5C3 5.84315 4.34315 4.5 6 4.5H18C19.6569 4.5 21 5.84315 21 7.5V12" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <circle cx="18" cy="18" r="4" stroke="#323232" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M19.3443 17.208L17.6643 18.887L16.6543 17.88" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 11.6905V13.4165C12 13.9688 11.5523 14.4165 11 14.4165H8C7.44772 14.4165 7 13.9688 7 13.4165V11.6425C7 11.2628 7.17262 10.9036 7.46915 10.6664L8.68915 9.6904C9.14567 9.3252 9.79433 9.3252 10.2508 9.6904L11.5308 10.7144C11.8274 10.9516 12 11.3108 12 11.6905V11.6905Z" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                  </span>
                </div>
                <div className="d-flex flex-column">
                  <p className="p1-light text-dark mb-0">Ready For Discharge</p>
                  <h3 className="h3-strong mb-0">{appointmentCounts.Discharge}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-6 py-1">
              <div className="d-flex sh_statusIndicatorbox olivegreen px-3 py-2">
                <div className="d-flex align-items-center ">
                  <span className="sh_statusIndicator bg-light">
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 3H6C4.34315 3 3 4.34315 3 6V9" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M17 21H18C19.6569 21 21 19.6569 21 18V13" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <ellipse cx="17" cy="7" rx="4" ry="4" stroke="#323232" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M18.25 6.5L16.6883 8L15.75 7.1" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <ellipse cx="8" cy="13.5" rx="2.5" ry="2.5" stroke="#323232" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13 21C13 19.6193 11.8807 18.5 10.5 18.5H5.5C4.11929 18.5 3 19.6193 3 21" stroke="#1D2433" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                 </svg>

                  </span>
                </div>
                <div className="d-flex flex-column">
                  <p className="p1-light text-dark mb-0">Completed</p>
                  <h3 className="h3-strong mb-0">{appointmentCounts.completed}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div className="sh_cardBody p-0 position-relative">
          <div
            className="card shadow-none border-0 bg-transparent"
            style={{ position: "absolute", inset: "0" }}
          >
            <div className="sh_innerPortview w-100">
              <CalendarBody
                {...this.props}
                calendarHocProps={{
                  direction: this.state.direction,
                  currentDay: this.state.currentDay,
                  isShowMorePopup: isShowMorePopup,
                  isShowQuickViewPopup: isShowQuickViewPopup,
                  anchorTagPosition: anchorTagPosition,
                  popupCalendarData: popupCalendarData,
                  visitStatusOption: visitStatusOption,
                  quickViewDetails: quickViewDetails,
                  calendarActionHandler: this.refetchCalendarDetails,
                  modalToogle: this.openViewMorePopupToogle,
                  quickViewModalToogle: this.openQuickVisitViewPopupToogle,
                  viewVisitHandler: this.props.viewVisitHandler,
                  showQuickVisitView: this.showQuickVisitView,
                }}
                currentDay={currentDay}
                todayDate={fetchCurrentDate()}
                calendarOptions={calendarOptions}
                showQuickVisitView={this.showQuickVisitView}
                calendarViewType={calendarViewType}
                showMoreDetailsDataHandler={this.showMoreCalendarGridForm}
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  currentDayChangeHandler = async (val, type = null) => {
    const { calendarViewType } = this.props;
    this.setState(
      {
        currentDay: val,
        direction: type,
        calendarLabel: this.updateCalendarLabel(val, calendarViewType),
      },
      () => {
        let calendarParam = {};
        calendarParam = getDateRangeHandler(calendarViewType, val);
        this.props.calendarActionHandler(calendarViewType, calendarParam, val);
      }
    );
  };
  refetchCalendarDetails = () => {
    let calendarParam = {};
    const { calendarViewType } = this.props;
    const { currentDay } = this.state;
    calendarParam = getDateRangeHandler(calendarViewType, currentDay);
    this.props.calendarActionHandler(
      calendarViewType,
      calendarParam,
      currentDay
    );
  };
  calendarViewTypeChangeHandler = (viewType) => {
    let { currentDay } = this.state;
    this.setState(
      {
        direction: null,
        calendarLabel: this.updateCalendarLabel(currentDay, viewType),
        currentDay: currentDay,
      },
      () => {
        //console.log('calendarViewTypeChangeHandler===',currentDay)
        let calendarParam = {};
        calendarParam = getDateRangeHandler(viewType, currentDay);
        //console.log('calendarViewTypeChangeHandler==',calendarParam)
        //await this.props.changeGridViewHandler('CALENDAR',{},true,viewType,calendarParam,currentDay)
        this.props.calendarActionHandler(viewType, calendarParam, currentDay);
        //  this.scrolIntoStartingtime();
      }
    );
  };
  updateCalendarLabel = (currentDay, calendarViewType) => {
    //Default Month view label
    let calendarLabel =
      MONTHS[currentDay.getMonth()] + " " + currentDay.getFullYear();
    if (calendarViewType === "DAY") {
      //Day view Label
      calendarLabel =
        currentDay.getDate() +
        " " +
        MONTHS[currentDay.getMonth()] +
        " " +
        currentDay.getFullYear();
    } else if (calendarViewType === "WEEK") {
      //Week view label
      let firstDayOfWeek = new Date(
        currentDay.setDate(currentDay.getDate() - currentDay.getDay())
      );
      const lastDayOfWeek = new Date(
        currentDay.getFullYear(),
        currentDay.getMonth(),
        currentDay.getDate() + 6
      );
      const fromDateStr = firstDayOfWeek.getDate();
      const fromDateMonth = MONTHS_SHORT[firstDayOfWeek.getMonth()];
      const fromDateYear = firstDayOfWeek.getFullYear();
      const toDateMonth = MONTHS_SHORT[lastDayOfWeek.getMonth()];
      const toDateYear = lastDayOfWeek.getFullYear();
      const toDateStr = lastDayOfWeek.getDate();

      const fromDateMonthStr = fromDateMonth;
      const fromDateYearStr =
        fromDateYear !== toDateYear ? ", " + fromDateYear : "";
      const toDateMonthStr = fromDateMonth === toDateMonth ? "" : toDateMonth;
      const toDateYearStr = ", " + toDateYear;

      calendarLabel =
        fromDateMonthStr + " " + fromDateStr + fromDateYearStr + " - ";
      calendarLabel += toDateMonthStr + " " + toDateStr + toDateYearStr;
    }
    return calendarLabel;
  };
}

Calendar.defaultProps = {
  currentDay: fetchCurrentDate(),
  calendarViewType: "WEEK",
};
export default withReduxState(Calendar);
